"use client";
import React from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import { cn } from "@/lib/utils";
const transition = {
  type: "spring",
  mass: 0.5,
  damping: 11.5,
  stiffness: 100,
  restDelta: 0.001,
  restSpeed: 0.001,
};

export const MenuItem = ({
  setActive,
  active,
  item,
  navigation,
  children,
  className
}) => {
  return (
    (<div onMouseEnter={() => setActive(item)} className="relative  text-white">
      <motion.p
        transition={{ duration: 0.3 }}
       
        className={cn(
         "cursor-pointer text-white text-sm md:text-base md:font-semibold tracking-wide hover:text-brand-300 transition-colors duration-200 dark:text-white",
          className
        )}
        >
       <Link href={navigation}>
        {item}
      </Link>
      </motion.p>
      {active !== null && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={transition}>
          {active === item && (
            <div
              className="absolute top-[calc(100%_+_1.2rem)] left-1/2 transform -translate-x-1/2 pt-4">
              <motion.div
                transition={transition}
                layoutId="active"
                className="glass-nav rounded-2xl overflow-hidden shadow-glow-lg">
                <motion.div
                  layout
                  className="w-max h-full p-5">
                    {children}
                </motion.div>
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </div>)
  );
};

export const Menu = ({
  setActive,
  children
}) => {
  return (
    (<nav
      // resets the state
      onMouseLeave={() => setActive(null)}
      className="glass-nav relative rounded-full text-white flex justify-between items-center space-x-4 px-6 md:px-8 py-4 md:py-5">

      {children}
    </nav>)
  );
};



export const HoveredLink = ({
  children,
  className,
  ...rest
}) => {
  return (
    (<Link
      {...rest}
      className={cn(
        "text-slate-200 font-medium text-sm hover:text-brand-300 hover:translate-x-1 inline-block transition-all duration-200",
        className
      )}
      >
      {children}
    </Link>)
  );
};
